import BaseComponent from 'scripts/BaseComponent.js';
import Swiper, {
  Pagination, Navigation, Lazy, EffectFade,
} from 'swiper';

export default class ProductImages extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      imageSlider: '.js-imageSlider',
      prevImageBtn: '.js-prevImageBtn',
      nextImageBtn: '.js-nextImageBtn',
      pagination: '.js-imageSliderPagination',
      imageCover: '.js-imageCover',
      imageZoomBtn: '.js-imageZoomBtn',
    };

    this.dom = {
      $component: component,
      $imageSlider: this.$get(this.refs.imageSlider),
      $prevImageBtn: this.$get(this.refs.prevImageBtn),
      $nextImageBtn: this.$get(this.refs.nextImageBtn),
      $pagination: this.$get(this.refs.pagination),
      $imageCover: this.$get(this.refs.imageCover),
    };

    this.state = {
      swiper: null,
      revealClass: 'reveal',
      removeClass: 'remove',
      animationTiming: 500,
      updateZoomImageEvent: 'updatezoomimage',
      swiperSlideToFirstEvent: 'swiperslidetofirst',
    };

    this.mount();
    this.init();
  }

  mount() {
    const { state } = this;
    super.mount();

    this.setOnCustomEvent(state.swiperSlideToFirstEvent, this.setFirstSlide);
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state, refs } = this;

    state.swiper = new Swiper(dom.$imageSlider, {
      modules: [Pagination, Navigation, Lazy, EffectFade],
      loop: true,
      preloadImages: false,
      effect: 'fade',
      pagination: {
        el: dom.$pagination,
        bulletClass: 'ProductImages__bullet',
        bulletActiveClass: 'is-active-slide',
      },
      navigation: {
        prevEl: dom.$prevImageBtn,
        nextEl: dom.$nextImageBtn,
      },
      lazy: {
        loadOnTransitionStart: true,
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
    });

    // Handle cover removal for first image (not lazy-loaded for LCP)
    const firstImage = dom.$imageSlider.querySelector('.js-featuredImage');
    if (firstImage) {
      if (firstImage.complete) {
        this.removeImageCover();
      } else {
        firstImage.addEventListener('load', this.removeImageCover.bind(this), { once: true });
      }
    } else {
      // Fallback: wait for any lazy image
      state.swiper.once('lazyImageReady', this.removeImageCover.bind(this));
    }

    this.setClickWithElement(this.$getAll(refs.imageZoomBtn), this.imageZoomClick);
  }

  removeImageCover() {
    const { dom, state } = this;

    dom.$imageCover.classList.add(state.revealClass);
    setTimeout(() => dom.$imageCover.classList.add(state.removeClass), state.animationTiming);
  }

  imageZoomClick(btn) {
    const { state } = this;
    const { imageSrc, imageSrcsets, variantImage } = btn.dataset;
    const details = { imageSrc, imageSrcsets };

    if (variantImage) {
      details.variantImage = true;
    }

    this.dispatch(state.updateZoomImageEvent, details);
  }

  setFirstSlide() {
    const { state } = this;
    state.swiper.slideTo(1);
  }
}
